import { gaEvent } from '../common/services/analytics'
import { deleteItem, postJSON } from '../common/services/api'
import * as DataOperations from './Data'

export function deleteDocument(id, listId) {
  return (dispatch) => {
    return deleteItem(id, listId)
      .then(() => {
        dispatch(DataOperations.loadList(listId))
        gaEvent({
          category: 'Documents',
          action: `Deleted a document`
        })
      })
      .catch((err) => {
        console.error(err)
      })
  }
}

export function archiveDocument(id, reason, listId) {
  return (dispatch) => {
    return postJSON({
      url: `/v6/documents/${id}/archive`,
      method: 'POST',
      json: { reason }
    })
      .then(() => {
        dispatch(DataOperations.loadList(listId))
        gaEvent({
          category: 'Documents',
          action: `Archived a document`
        })
      })
      .catch((err) => {
        console.error(err)
        throw err
      })
  }
}

export function restoreDocument(id, listId) {
  return (dispatch) => {
    return postJSON({
      url: `/v6/documents/${id}/restore`,
      method: 'POST'
    })
      .then(() => {
        dispatch(DataOperations.loadList(listId))
        gaEvent({
          category: 'Documents',
          action: `Restored a document`
        })
      })
      .catch((err) => {
        console.error(err)
        throw err
      })
  }
}
